import { pt } from "date-fns/locale";

export const sharedFormStyles = {
  pageContainer: {
    padding: 0,
    width: '100%',
    m: 2
  },
  formCard: {
    p: 2,
    height: '100%',
    border: '1px solid #e5e7eb',
    backgroundColor: 'white',
  },
  sectionTitle: {
    fontSize: '0.875rem',
    fontWeight: 700,
    color: '#111827',
    mb: 2,
  },
  formGrid: {
    rowSpacing: 1,
    columnSpacing: 4,
  },
  radioGroupRow: {
    minHeight: '25px',
    alignItems: 'center',
    gap: 0.5,
    m: 0,
    '& .MuiFormControlLabel-root': {
      m: 0,
      mr: 2,
      minHeight: '25px',
    },
    '& .MuiRadio-root': {
      p: '2px',
    },
    '& .MuiRadio-root .MuiSvgIcon-root': {
      fontSize: '1.1rem',
    },
  },
  radioGroupLabel: {
    '& .MuiFormControlLabel-label': {
      fontSize: '0.875rem',
      lineHeight: 1.2,
    },
  },
  actionBar: {
    mt: 1,
    display: 'flex',
    justifyContent: 'flex-end',
    gap: 2,
  },
  secondaryButton: {
    borderRadius: 0.5,
    textTransform: 'none',
    borderColor: '#d1d5db',
    color: '#374151',
    '&:hover': {
      borderColor: '#9ca3af',
      backgroundColor: '#f9fafb',
    },
  },
  primaryButton: {
    marginTop: '16px !important',
    '&.MuiButton-root': {
      marginTop: '16px !important',
    },
    borderRadius: 0.5,
    textTransform: 'none',
    backgroundColor: '#1976d2',
    '&:hover': {
      backgroundColor: '#1565c0',
    },
    '&:disabled': {
      backgroundColor: '#e5e7eb',
      color: '#9ca3af',
    },
  },
  cancelButton: {
    marginTop: '8px !important',
    '&.MuiButton-root': {
      marginTop: '16px !important',
    },
    borderRadius: 0.5,
    textTransform: 'none',
    backgroundColor: '#6b7280',
    '&:hover': {
      backgroundColor: '#4b5563',
    },
    '&:disabled': {
      backgroundColor: '#e5e7eb',
      color: '#9ca3af',
    },
  },
  additionalImagesContainer: {
    display: 'flex',
    gap: 2,
    flexWrap: 'wrap',
    justifyContent: 'center',
    mb: 2,
  },
  additionalImageItem: {
    width: { xs: '100%', sm: 230},
  },
  additionalImageCard: {
    borderRadius: 0.5,
    p: 1.25,
    pt:0,
    pb:0,
    backgroundColor: '#fafafa',
  },
  additionalImageTitle: {
    fontSize: '0.85rem',
    fontWeight: 600,
    color: '#374151',
    mb: 1,
  },
  additionalImageUploadWrapper: {
    width: 200,
    mx: 'auto',
  },
  additionalImageUploadHeight: 130,
  additionalImageUploadBackground: '#f3f4f6',
  additionalImageUploadBorderRadius: '2px',
  additionalTextGrid: {
    mb: 0,
  },
  additionalTextarea: (canEdit: boolean) => ({
    width: '100%',
    fontSize: '0.875rem',
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    padding: '10px 12px',
    borderRadius: '2px',
    border: '1px solid #d1d5db',
    outline: 'none',
    backgroundColor: canEdit ? '#fff' : '#f9fafb',
    color: '#374151',
    resize: 'vertical' as const,
    boxSizing: 'border-box' as const,
  }),
  formPageContainer: {
    padding: 0,
    width: '100%',
    m: 2,
    flex: 1,
    height: '100%',
    overflow: 'auto',
  },
  inputArrowAlign: {
    width: '100%',
    '& .MuiInputBase-root': {
      pr: '26px !important',
    },
    '& .MuiSelect-select': {
      pr: '26px !important',
    },
    '& .MuiSelect-icon, & .MuiSelect-iconOutlined': {
      right: '0 !important',
      top: '50%',
      transform: 'translateY(-50%)',
      color: '#6b7280',
    },
    '& .MuiAutocomplete-endAdornment': {
      right: '0 !important',
      top: '50%',
      transform: 'translateY(-50%)',
    },
    '& .MuiAutocomplete-popupIndicator': {
      p: 0,
      m: 0,
      minWidth: 18,
      minHeight: 18,
      color: '#6b7280',
    },
    '& .MuiAutocomplete-popupIndicator .MuiSvgIcon-root': {
      fontSize: 18,
    },
    '& .MuiAutocomplete-clearIndicator': {
      display: 'none',
    },
  },
  datePickerArrowAlign: {
    width: '100%',
    '& .MuiInputBase-root': {
      pr: '26px !important',
      position: 'relative',
    },
    '& .MuiInputAdornment-root': {
      position: 'absolute',
      right: '0 !important',
      top: '50%',
      transform: 'translateY(-50%)',
      marginRight: '0 !important',
    },
    '& .MuiInputAdornment-root .MuiIconButton-root': {
      p: 0,
      m: 0,
      minWidth: 18,
      minHeight: 18,
      color: '#6b7280',
    },
    '& .MuiInputAdornment-root .MuiSvgIcon-root': {
      fontSize: 18,
    },
  },
  formControlFullWidth: {
    width: '100%',
    minWidth: 0,
    '& .MuiInputBase-root': {
      width: '100%',
      minWidth: 0,
    },
  },
  autocompleteFullWidth: {
    width: '100%',
    minWidth: 0,
    display: 'block',
    '& .MuiInputBase-root': {
      width: '100%',
      minWidth: 0,
    },
    '& .MuiAutocomplete-inputRoot': {
      width: '100%',
      minWidth: 0,
    },
  },
  groupedOptionRow: {
    display: 'flex',
    alignItems: 'center',
    gap: 1,
    width: '100%',
  },
  roleSelectorLoadingBox: {
    display: 'flex',
    alignItems: 'center',
    gap: 1,
    p: 2,
    border: '1px solid #d1d5db',
    borderRadius: 1,
    backgroundColor: '#f9fafb',
  },
  roleSelectorErrorBox: {
    p: 2,
    border: '1px solid #ef4444',
    borderRadius: 1,
    backgroundColor: '#fef2f2',
  },
  multiSelectInput: {
    '& .MuiOutlinedInput-root': {
      borderRadius: 1,
      '& fieldset': { borderColor: '#e5e7eb' },
      '&:hover fieldset': { borderColor: '#d1d5db' },
      '&.Mui-focused fieldset': { borderColor: '#3b82f6' },
    },
  },
  multiSelectChip: {
    color: '#0277bd',
    '& .MuiChip-deleteIcon': {
      color: '#0277bd',
    },
  },
  multiSelectOptionText: {
    fontWeight: 400,
    pl: 1.5,
  },
  multiSelectGroupContainer: {
    '& .MuiAutocomplete-groupLabel': {
      py: 0.25,
      px: 1.5,
      fontWeight: 700,
      fontSize: '0.8rem',
      lineHeight: 1.3,
    },
    '& .MuiAutocomplete-groupUl': {
      py: 0,
      mb: 0.25,
    },
  },
  multiSelectGroupList: {
    pl: 0,
  },
  groupedOptionCategoryLabel: (isIncome: boolean) => ({
    fontWeight: 600,
    color: isIncome ? '#4caf50' : '#ff9800',
    minWidth: '80px',
  }),
  optionNameText: {
    fontWeight: 500,
  },
  amountInputText: {
    '& .MuiInputBase-input': {
      textAlign: 'right',
      padding: '0 0 4px 0',
    },
  },
  noteSectionWrapper: {
    mt: 2,
  },
  compactSectionTitle: {
    mb: 0,
    color: '#1f2937',
    fontSize: '0.875rem',
    fontWeight: 700,
  },
  noteTextarea: (canEdit: boolean) => ({
    width: '100%',
    fontSize: '0.875rem',
    fontWeight: 400,
    padding: '8px 12px',
    fontFamily: 'inherit',
    lineHeight: '1.5',
    border: '1px solid #e5e7eb',
    borderRadius: '4px',
    resize: 'none' as const,
    cursor: canEdit ? 'text' : 'not-allowed',
    opacity: canEdit ? 1 : 0.6,
    backgroundColor: canEdit ? 'transparent' : '#f3f4f6',
    outline: 'none',
  }),
  summaryRow: {
    mb: 2,
    display: 'flex',
    alignItems: 'center',
    gap: 2,
  },
  summaryLabel: {
    fontWeight: 600,
    color: '#374151',
    minWidth: '180px',
  },
  summaryValueContainer: {
    flex: 1,
    display: 'flex',
    justifyContent: 'flex-end',
  },
  summaryInputContainer: {
    flex: 1,
    width: '100%',
    minWidth: 0,
  },
  summaryValueText: {
    textAlign: 'right',
    fontWeight: 600,
    color: '#374151',
  },
  summaryNumericInput: {
    '& .MuiInputBase-input': {
      textAlign: 'right',
      padding: '8px 12px',
    },
  },
  summarySuccessHeading: {
    fontWeight: 700,
    color: '#10b981',
    fontSize: '0.95rem',
    borderBottom: '2px solid #10b981',
    paddingBottom: '4px',
  },
  summaryDividerRow: {
    mb: 2,
    display: 'flex',
    alignItems: 'center',
    gap: 2,
    pt: 1,
    borderTop: '1px solid #e5e7eb',
  },
  summarySuccessLabel: {
    fontWeight: 600,
    color: '#10b981',
    minWidth: '180px',
  },
  summarySuccessValue: {
    textAlign: 'right',
    fontWeight: 600,
    color: '#10b981',
  },
  summarySuccessValueStrong: {
    textAlign: 'right',
    fontWeight: 700,
    color: '#10b981',
    fontSize: '1rem',
  },
  summaryDangerLabelStrong: {
    fontWeight: 700,
    color: '#dc2626',
    minWidth: '180px',
    fontSize: '1rem',
  },
  summaryDangerValueStrong: {
    textAlign: 'right',
    fontWeight: 700,
    color: '#dc2626',
    fontSize: '1rem',
  },
  fileUploadContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
  },
  fileUploadDropzone: (hasSelectedFiles: boolean) => ({
    p: 3,
    border: '2px dashed',
    borderColor: hasSelectedFiles ? 'primary.main' : 'divider',
    borderRadius: 2,
    textAlign: 'center',
    cursor: 'pointer',
    transition: 'all 0.2s ease-in-out',
    bgcolor: hasSelectedFiles ? 'primary.light' : 'background.paper',
    '&:hover': {
      borderColor: 'primary.main',
      bgcolor: 'primary.light',
    },
  }),
  fileUploadIcon: {
    fontSize: 48,
    color: 'text.secondary',
    mb: 1,
  },
  fileUploadTitle: {
    fontWeight: 600,
    mb: 0.5,
  },
  hiddenFileInput: {
    display: 'none',
  },
  fileLoadingBox: {
    textAlign: 'center',
    py: 2,
  },
  fileListBox: {
    display: 'flex',
    flexDirection: 'column',
    gap: 1,
  },
  uploadedFilesTitle: {
    fontWeight: 600,
    color: 'success.main',
  },
  selectedFilesTitle: {
    fontWeight: 600,
  },
  uploadedFileItem: {
    p: 2,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    border: '1px solid',
    borderColor: 'success.light',
    borderRadius: 1,
    bgcolor: 'success.lighter',
  },
  selectedFileItem: {
    p: 2,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    border: '1px solid',
    borderColor: 'divider',
    borderRadius: 1,
  },
  fileMetaRow: {
    display: 'flex',
    alignItems: 'center',
    gap: 1,
  },
  successStatusIcon: {
    color: 'success.main',
  },
  primaryStatusIcon: {
    color: 'primary.main',
  },
  destructiveIconButton: {
    color: 'error.main',
  },
  orderItemsTableStyles: {
    sectionWrapper: { mt: 2 },
    title: {
      fontSize: '0.875rem',
      fontWeight: 700,
      color: '#111827',
      marginBottom: '20px',
      borderBottom: '2px solid #e5e7eb',
      paddingBottom: '12px',
    },
    tableContainer: (tableWidth: number, horizontalPadding: number = 0) => ({
      overflowX: 'auto',
      overflowY: 'visible',
      width: tableWidth > 0 ? `${Math.max(tableWidth - horizontalPadding, 320)}px` : '100%',
      maxWidth: '100%',
      paddingBottom: '12px',
      boxSizing: 'border-box' as const,
      border: '1px solid #e5e7eb',
      borderRadius: 1,
      '&::-webkit-scrollbar': {
        height: '8px',
      },
      '&::-webkit-scrollbar-track': {
        backgroundColor: '#f1f1f1',
        borderRadius: '4px',
      },
      '&::-webkit-scrollbar-thumb': {
        backgroundColor: '#c1c1c1',
        borderRadius: '4px',
        '&:hover': {
          backgroundColor: '#a8a8a8',
        },
      },
    }),
    table: { minWidth: 'max-content', tableLayout: 'auto' as const },
    headRow: { backgroundColor: '#f9fafb' },
    headIndexBox: { textAlign: 'center' },
    actionBar: {
      display: 'flex',
      mt: 2,
      gap: 2,
    },
    addButton: {
      borderRadius: 0.5,
      textTransform: 'none',
      borderColor: '#d1d5db',
      color: '#6b7280',
      '&:hover': {
        borderColor: '#9ca3af',
        backgroundColor: '#f9fafb',
      },
    },
    row: (itemIsGroup: boolean, isDragging: boolean) => ({
      backgroundColor: itemIsGroup ? '#f3f4f6' : 'inherit',
      cursor: isDragging ? 'grabbing' : 'grab',
      '&:hover .delete-icon': {
        opacity: 1,
      },
    }),
    dragCell: { width: '60px', minWidth: '60px', maxWidth: '60px', pl: '8px', position: 'relative' as const },
    dragButton: (disabled: boolean) => ({
      position: 'absolute' as const,
      left: 0,
      top: '5px',
      cursor: disabled ? 'default' : 'grab',
      p: 0,
      minWidth: 'auto',
      '&:hover': { backgroundColor: 'rgba(0,0,0,0.04)' },
    }),
    dragIcon: { color: '#9ca3af' },
    dragCellInner: { alignItems: 'center' },
    indexText: {
      marginRight: 'auto',
      fontSize: '0.75rem',
      fontWeight: 500,
      color: '#6b7280',
      textAlign: 'center',
    },
    productCell: {
      width: '300px',
      minWidth: '300px',
      maxWidth: '300px',
      verticalAlign: 'top' as const,
      overflow: 'hidden' as const,
    },
    colorCell: {
      width: '120px',
      minWidth: '120px',
      maxWidth: '120px',
      verticalAlign: 'top' as const,
      overflow: 'hidden' as const,
    },
    quantityCell: { width: '100px', minWidth: '100px', maxWidth: '100px' },
    unitCell: { width: '170px', minWidth: '170px', maxWidth: '170px' },
    unitPriceCell: { width: '150px', minWidth: '150px', maxWidth: '150px' },
    totalCell: { width: '150px', minWidth: '150px', maxWidth: '150px' },
    taxCell: { width: '130px', minWidth: '170px' },
    vatCell: { width: '150px', minWidth: '150px', maxWidth: '150px' },
    groupDeleteCell: { width: '50px', minWidth: '50px', maxWidth: '50px' },
    unitWrapper: { position: 'relative' as const },
    totalText: { pt: '5px' },
    deleteButton: (disabled: boolean) => ({
      color: '#ef4444',
      opacity: disabled ? 0 : 0,
      transition: 'opacity 0.2s ease-in-out',
    }),
    productNameTextarea: (itemIsGroup: boolean, disabled: boolean) => ({
      width: '100%',
      boxSizing: 'border-box' as const,
      fontSize: itemIsGroup ? '14px' : '0.875rem',
      fontWeight: itemIsGroup ? 600 : 400,
      padding: 0,
      fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
      color: '#374151',
      lineHeight: '1.5',
      border: 'none',
      borderRadius: '4px',
      resize: 'none' as const,
      cursor: disabled ? 'not-allowed' : 'text',
      opacity: disabled ? 0.6 : 1,
      backgroundColor: disabled ? '#f3f4f6' : 'transparent',
      outline: 'none',
      whiteSpace: 'pre-wrap' as const,
      wordBreak: 'break-word' as const,
      overflowWrap: 'anywhere' as const,
      overflow: 'hidden' as const,
    }),
    colorTextarea: (disabled: boolean) => ({
      width: '100%',
      boxSizing: 'border-box' as const,
      fontSize: '0.875rem',
      fontWeight: 400,
      padding: 0,
      fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
      color: '#374151',
      lineHeight: '1.5',
      border: 'none',
      borderRadius: '4px',
      resize: 'none' as const,
      cursor: disabled ? 'not-allowed' : 'text',
      opacity: disabled ? 0.6 : 1,
      backgroundColor: disabled ? '#f3f4f6' : 'transparent',
      outline: 'none',
      whiteSpace: 'pre-wrap' as const,
      wordBreak: 'break-word' as const,
      overflowWrap: 'anywhere' as const,
      overflow: 'hidden' as const,
    }),
    quantityInput: {
      '& .MuiInputBase-input': {
        textAlign: 'right' as const,
        padding: '0 0 4px 0',
      },
      '& .MuiInputBase-root': {
        height: '30px',
        minHeight: '30px',
        maxHeight: '30px',
        backgroundColor: 'transparent',
        overflow: 'visible',
        border: 'none !important',
        borderBottom: '1px solid #d1d5db',
        borderRadius: 0,
      },
    },
    unitAutocomplete: {
      width: '100%',
      '& .MuiInputBase-root': {
        pr: '26px !important',
        height: '30px',
        minHeight: '30px',
        maxHeight: '30px',
        backgroundColor: 'transparent',
        overflow: 'visible',
        border: 'none !important',
        borderBottom: '1px solid #d1d5db',
        borderRadius: 0,
        color: '#374151 !important',
        '&:hover': {
          borderBottom: '1px solid #9ca3af',
        },
        '&.Mui-focused': {
          borderBottom: '1px solid #3b82f6 !important',
          border: 'none !important',
        },
      },
      '& .MuiInputBase-input': {
        color: '#374151 !important',
      },
      '& .MuiOutlinedInput-notchedOutline': {
        border: 'none !important',
      },
      '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
        border: 'none !important',
      },
      '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
        border: 'none !important',
      },
      '& .MuiOutlinedInput-root': {
        border: 'none !important',
        '&:hover': {
          border: 'none !important',
        },
        '&.Mui-focused': {
          border: 'none !important',
        },
      },
      '& .MuiAutocomplete-clearIndicator': {
        display: 'none',
      },
      '& .MuiAutocomplete-popupIndicator': {
        display: 'none',
      },
    },
    unitPriceInput: {
      '& .MuiInputBase-input': {
        textAlign: 'right' as const,
        padding: '0 0 4px 0',
      },
      '& .MuiInputBase-root': {
        height: '30px',
        minHeight: '30px',
        maxHeight: '30px',
        backgroundColor: 'transparent',
        overflow: 'visible',
        border: 'none !important',
        borderBottom: '1px solid #d1d5db',
        borderRadius: 0,
      },
    },
    taxSelect: {
      width: '100%',
      backgroundColor: 'transparent',
      border: 'none !important',
      borderBottom: '1px solid #d1d5db',
      borderRadius: 0,
      fontSize: '0.875rem',
      '& .MuiInputBase-root': {
        pr: '26px !important',
      },
      '& .MuiSelect-select': {
        pr: '26px !important',
        padding: '4px 8px',
      },
      '& .MuiSelect-icon, & .MuiSelect-iconOutlined': {
        right: '0 !important',
        top: '50%',
        transform: 'translateY(-50%)',
        color: '#6b7280',
      },
      '& .MuiOutlinedInput-notchedOutline': {
        border: 'none !important',
      },
      '&:hover': {
        borderBottom: '1px solid #9ca3af',
      },
      '&.Mui-focused': {
        borderBottom: '1px solid #3b82f6 !important',
      },
    },
    headActionWidthCell: { width: '50px', minWidth: '50px', maxWidth: '50px' },
    headIndexCellCombined: {
      width: '40px',
      minWidth: '40px',
      maxWidth: '40px',
      fontWeight: 600,
    },
    headProductCellCombined: {
      width: '300px',
      minWidth: '300px',
      maxWidth: '300px',
      fontWeight: 600,
      color: '#374151',
    },
    headColorCellCombined: {
      width: '320px',
      minWidth: '320px',
      fontWeight: 600,
      color: '#374151',
    },
    headQuantityCellCombined: {
      width: '100px',
      minWidth: '100px',
      maxWidth: '100px',
      fontWeight: 600,
      color: '#374151',
    },
    headUnitCellCombined: {
      width: '170px',
      minWidth: '170px',
      maxWidth: '170px',
      fontWeight: 600,
      color: '#374151',
    },
    headUnitPriceCellCombined: {
      width: '200px',
      minWidth: '200px',
      maxWidth: '200px',
      fontWeight: 600,
      color: '#374151',
    },
    headTotalCellCombined: {
      width: '200px',
      minWidth: '200px',
      maxWidth: '200px',
      fontWeight: 600,
      color: '#374151',
    },
    headTaxCellCombined: {
      width: '100px',
      minWidth: '100px',
      fontWeight: 600,
      color: '#374151',
    },
    headVatCellCombined: {
      width: '200px',
      minWidth: '200px',
      maxWidth: '200px',
      fontWeight: 600,
      color: '#374151',
    },
  },
  hiddenContainer: {
    display: 'none',
  },
};
